export const AUDIO_NO_RESULT_LIGHT =
  'https://static.rfstat.com/renderforest/images/v2/video-editor/audio-no-result-light.png'

export const DROPDOWN_NO_RESULTS_PNG = `https://s3.us-west-2.amazonaws.com/static.rfstat.com/renderforest/images/v2/video-editor-v2/dropdown-no-results.png`
export const SOUNDS_NO_RESULT_PNG =
  'https://static.rfstat.com/renderforest/images/v2/video-editor-v2/sounds-no-result.png'
